import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import swal from 'sweetalert2';
import { Location } from "@angular/common";


@Injectable()
export class Dialogs {

	constructor(private router: Router, private location: Location) { }



	showWarning(title: string, message: string, route?: string) {
        let self =this
        return swal({
            title: title,
            text: message,
            type: 'warning',
            confirmButtonText: 'Ok'
        }).then(
            function () {
                if (route != "" && route != undefined) {
                    if (route == "reload") {
                        location.reload();
                    } else {
                        self.router.navigate([route]);
                    }
                }else {
					self.location.back();
				}
            }
            );
	}



    showError(title: string, message: string, route?: string) {
        let self =this
        return swal({
            title: title,
            text: message,
            type: 'error',
            confirmButtonText: 'Ok'
        }).then(
            function () {
                if (route != "" && route != undefined) {
                    if (route == "reload") {
                        location.reload();
                    } else {
                        self.router.navigate([route]);
                    }
                }
            }
            );
	}

	showAskDelete(title: string, text: string) {
		let self = this;
		return swal({
			title: title,
			text: text,
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#999999',
			confirmButtonText: 'Sí',
			cancelButtonText: 'No'
        });
	}

	showCancel(route: string, show: boolean, back?: boolean) {
		let self = this;
		if (show) {
			swal({
				title: 'Els canvis es perdràn',
				text: "Segur que vols perdre els canvis?",
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#999999',
				confirmButtonText: 'Sí',
				cancelButtonText: 'No'
			}).then(
				function () {
					//console.log(back);
					if (back)
						self.location.back();
					else
						self.router.navigate([route]);
				},
				function (dissimis) {
				}
				);
		} else {
			if (back)
				self.location.back();
			else
				self.router.navigate([route]);
		}
	}

	showItemUploaded(title: string, message: string, route?: string, back?: boolean) {
		let self = this;
		return swal({
			title: title,
			text: message,
			type: 'success',
			confirmButtonText: 'Ok'
		}).then(
			function () {
                if (route != "" && route != undefined) {
                    if (route == "reload") {
                        location.reload();
                    } else {
                        self.router.navigate([route]);
                    }
				} else {
					if (back)
						self.location.back();
				}
			}
			);
	}

	showItemDeleted(title: string, message: string): Promise<any> {
		return swal({
			title: title,
			text: message,
			type: 'success',
			confirmButtonText: 'Ok'
		});
	}

}


// WEBPACK FOOTER //
// ./src/app/common/dialogs.ts